const PLUGIN_NAME = 'ecommerce-events-kp';

export { PLUGIN_NAME };
